module.exports = __webpack_public_path__ + "static/img/three.401462e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teams/three.png
// module id = lyIo
// module chunks = 0